import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const firebaseConfig = {
  // apiKey: "AIzaSyAHB0XNIvATyUpWMB9_6wsZ6MlPH_n2UHs",
  // authDomain: "idcevent-40f47.firebaseapp.com",
  // databaseURL: "https://idcevent-40f47.firebaseio.com",
  // projectId: "idcevent-40f47",
  // storageBucket: "idcevent-40f47.appspot.com",
  // messagingSenderId: "954635213118",
  // appId: "1:954635213118:web:bbda9ae23e91645157346f",

  apiKey: "AIzaSyDifLvW6R4QDSOvFVWnSzePPtZUTrsj8BA",
  authDomain: "truly-nolen-82d58.firebaseapp.com",
  databaseURL: "https://truly-nolen-82d58.firebaseio.com",
  projectId: "truly-nolen-82d58",
  storageBucket: "truly-nolen-82d58.appspot.com",
  messagingSenderId: "239492777577",
  appId: "1:239492777577:web:df8605ba682095511dc4f8",
  measurementId: "G-F6DSYLLL6R",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.auth();
const storage = firebase.storage();

export { storage, firebaseConfig as default };
